import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useAutocompleteProductsQuery } from "@/partner/entities/products";
import { usePickerSearch } from "../model/usePickerSearch";
import { EntityPicker, type PickerOption } from "./EntityPicker";

interface ProductPickerProps {
  value: string | null;
  onChange: (productId: string | null) => void;
}

const isOption = (option: PickerOption | null): option is PickerOption =>
  Boolean(option);

/**
 * Продукт для PRODUCT_CARD на autocompleteProducts: подпись выбранного id
 * сервер возвращает в поле `value` того же запроса.
 */
export const ProductPicker: FC<ProductPickerProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const { setSearch, debouncedSearch } = usePickerSearch();
  const { data, loading } = useAutocompleteProductsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      input: debouncedSearch || undefined,
      value: value ? [value] : [],
    },
  });
  const selectedLabel = data?.autocompleteProducts.value.find(
    (option) => option?.value === value
  )?.label;

  return (
    <EntityPicker
      label={t("emailTemplates.blocks.product")}
      value={value}
      selectedLabel={selectedLabel}
      options={(data?.autocompleteProducts.options ?? []).filter(isOption)}
      loading={loading}
      onSearch={setSearch}
      onChange={onChange}
      error={!value}
    />
  );
};
